// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2YL6n","content":"styles_content__2TZ8O","textInputWidthDefault":"styles_textInputWidthDefault__1-Vk2","flexButton":"styles_flexButton__2Pdqc"};